var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"router":"","mode":"horizontal","default-active":_vm.path,"background-color":"#095933","text-color":"#ccc","active-text-color":"#ffd04b"}},_vm._l((_vm.menus),function(m,k){return _c('navi-item',{key:k,attrs:{"mdata":m}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da50840","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navi.vue
// module id = null
// module chunks = 